import type { CartStoreConfiguration } from "../types/cart.types";

const defaultConfiguration: CartStoreConfiguration = {
    concurrencyMode: "legacy",
};

let currentConfiguration: CartStoreConfiguration = { ...defaultConfiguration };
let wasConfigured = false;

export const configureCartStore = (configuration: CartStoreConfiguration): void => {
    if (wasConfigured) {
        if (currentConfiguration.concurrencyMode === configuration.concurrencyMode) return;

        throw new Error("El store del carrito ya fue configurado con otro modo de concurrencia.");
    }

    currentConfiguration = { ...configuration };
    wasConfigured = true;
};

export const getCartStoreConfiguration = (): Readonly<CartStoreConfiguration> =>
    currentConfiguration;

export const resetCartStoreConfigurationForTests = (): void => {
    currentConfiguration = { ...defaultConfiguration };
    wasConfigured = false;
};
